import { Layer } from '../UNSAFE_Layer';
import { HTMLAttributesSignalExcluded } from '../utils/UNSAFE_attributeUtils';

type Props = Pick<HTMLAttributesSignalExcluded<HTMLDivElement>, 'children'>;

export const WindowOverlay = ({ children }: Props) => {
  return (
    <Layer>
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          pointerEvents: 'none'
        }}>
        {children}
      </div>
    </Layer>
  );
};
